import _ from 'lodash';

import Wix from '../services/wix-sdk-polyfill';
import createBiMiddleware from '../middleware/bi-middleware';
import { createBi, hasBiToken, isNotDummyVisitorId } from './bi-helpers.js';
import * as forumsUouEvents from './forums-uou-events';
import * as forumsUsersEvents from './forums-users-events';
import * as wixlabsUsersEvents from './wixlabs-users-events';

const extendForumsUouEvent = (event, state) => ({
  member_id: (state.auth.currentUser || {})._id,
  biToken: Wix.Utils.getInstanceValue('biToken'),
  visitor_id: Wix.Utils.getInstanceValue('aid') || Wix.Utils.getInstanceValue('uid'),
  ...event,
});

export const forumsUouBiMiddleware = createBiMiddleware({
  bi: createBi({
    endpoint: forumsUouEvents.endpoint,
    src: forumsUouEvents.src,
  }),
  eventMap: forumsUouEvents.eventMap,
  extendEvent: extendForumsUouEvent,
  shouldLogEvent: _.overEvery(hasBiToken, isNotDummyVisitorId),
});

const extendForumsUsersEvent = event => ({
  biToken: Wix.Utils.getInstanceValue('biToken'),
  ...event,
});

export const forumsUsersBiMiddleware = createBiMiddleware({
  bi: createBi({
    endpoint: forumsUsersEvents.endpoint,
    src: forumsUsersEvents.src,
  }),
  eventMap: forumsUsersEvents.eventMap,
  extendEvent: extendForumsUsersEvent,
  shouldLogEvent: hasBiToken,
});

const extendWixlabsUsersEvent = event => ({
  biToken: Wix.Utils.getInstanceValue('biToken'),
  ...event,
});

export const wixlabsUsersBiMiddleware = createBiMiddleware({
  bi: createBi({
    endpoint: wixlabsUsersEvents.endpoint,
    src: wixlabsUsersEvents.src,
  }),
  eventMap: wixlabsUsersEvents.eventMap,
  extendEvent: extendWixlabsUsersEvent,
  shouldLogEvent: hasBiToken,
});



// WEBPACK FOOTER //
// ./app/bi-events/init-middleware.js